import $ from 'jquery';
import initTooltip from './initTooltipster';

export default function packageChannelsTooltip(selector) {

    const $elem = $(selector);

    const $options = {
        contentAsHTML: true,
        interactive: true,
        contentCloning: true,
        maxWidth: 314,
        side: 'right'
    };

    initTooltip($elem, $options);
}
